import React from 'react';
import { useSelector } from 'react-redux';

import { track } from 'apis/amethyst';
import { evSephoraBeautyInsider, SephoraInteraction } from 'events/sephora';
import { selectLoyaltyEmail } from 'selectors/sephora';
import useSephoraContext from 'hooks/useSephoraContext';

import css from 'styles/components/sephora/beautyInsiderFormHeader.scss';

export const EmailHeader = () => (
  // TODO: this needs the upcoming change from Nate
  <p className={css.copy}>
    Connect your Sephora Beauty Insider account to earn <strong>1 point for every $1</strong> spent on all Sephora purchases.&nbsp;
    <button className={css.linkButton} type="button">
      Learn More
    </button>
  </p>
);

export const ConnectHeader = () => (
  <p className={css.copy}>
    Connect your Sephora Beauty Insider account to earn <strong>1 point for every $1</strong> spent on all Sephora purchases.&nbsp;
    <button className={css.linkButton} type="button">
      Learn More
    </button>
  </p>
);

export const VerifyHeader = () => {
  const { sephoraEmail, setView } = useSephoraContext();
  const linkedEmail = useSelector(selectLoyaltyEmail);

  return (
    <p className={css.copy}>
      We found a Beauty Insider account for {sephoraEmail || linkedEmail}. A verification code was sent to your email.&nbsp;
      <button
        className={css.linkButton}
        type="button"
        onClick={() => {
          track(() => [evSephoraBeautyInsider, { interaction: SephoraInteraction.EDIT_EMAIL_BUTTON_CLICK }]);
          setView('linkEmail');
        }}
      >
        Edit email address
      </button>
    </p>
  );
};

const BeautyInsiderFormHeader = () => {
  const { view } = useSephoraContext();

  return {
    accountInfo: null,
    linkEmail: <EmailHeader />,
    verifyEmail: <VerifyHeader />,
    registerAccount: <ConnectHeader />
  }[view];
};

export default BeautyInsiderFormHeader;
